/*
 * Branded Best House: small helpers for the design forms (snippets/bb-design-form.liquid,
 * sections/bb-design-request.liquid). No libraries; every part fails quietly.
 *  1. Product pages remember the pieces looked at this visit (sessionStorage, titles only).
 *  2. "Email me my designs" stays hidden until the visitor has added a logo somewhere on the site
 *     (window.BBHouseLogo.peek(), read-only), then fills in the pieces and the logo's file name.
 *  3. Any date field marked data-bbh-approve shows the date to approve the proof by (window.BBDates).
 *  4. Any [data-bbh-stored] note names the logo the visitor already added.
 *  5. On ad landing pages, the form is shown from the start ([data-bbh-always]) and its hidden contact[Ad] field
 *     names the ad from the link (utm_campaign / utm_content), so requests can be counted per ad. When the link has
 *     no tags it uses the arrival bb-lead-source.js remembers, which only exists once the visitor's privacy choice
 *     allows analytics (Shopify's Customer Privacy API). This file keeps no copy of its own.
 *  6. "Getting sign-off first?" (snippets/bb-signoff-form): the pack picked on the product form goes along at send.
 *  7. "Remind me two weeks before my approve-by date": the form's date is required while the tick is on.
 *  8. "Send this page to my computer" (snippets/bb-share-page): touch screens only, and only until a logo is added;
 *     the phone's share sheet, or the link copied, or the link shown to copy by hand.
 *  9. The paid sample request (snippets/bb-sample-form): its hidden "Logo added on the site" field names the logo the
 *     visitor added (the same read-only peek).
 */
(function () {
  'use strict';
  if (window.bbHouseFormsReady) return;
  window.bbHouseFormsReady = true;
  var KEY = 'bbh-viewed';
  var MAX_AGE = 7 * 24 * 3600 * 1000; // the same 7 days the logo is kept

  // Pieces opened, newest first, kept across tabs (a cmd-click from the occasions page opens a new tab).
  function viewed() {
    try {
      var rec = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!rec || !rec.list || Date.now() - (rec.at || 0) > MAX_AGE) return [];
      return rec.list;
    } catch (e) { return []; }
  }
  function remember(title) {
    if (!title) return;
    try {
      var list = viewed().filter(function (t) { return t !== title; });
      list.unshift(title);
      localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), list: list.slice(0, 8) }));
    } catch (e) { /* storage blocked */ }
  }

  // "campaign / content" from the link's utm fields.
  function adTag(search) {
    function get(k) {
      var m = new RegExp('[?&]' + k + '=([^&#]*)').exec(search || '');
      if (!m) return '';
      var v;
      try { v = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return ''; }
      return v.replace(/[\u0000-\u001f\u007f<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, 80);
    }
    return [get('utm_campaign'), get('utm_content')].filter(Boolean).join(' / ');
  }
  window.BBHouseForms = { adTag: adTag };
  function initAd(input) {
    if (input.dataset.bbhReady) return;
    input.dataset.bbhReady = '1';
    var tag = adTag(window.location.search);
    if (tag) { input.value = tag; return; }
    // a reload or a step back: the arrival bb-lead-source.js remembered (nothing without consent)
    if (window.BBLeadSource) {
      window.BBLeadSource.ready(function () {
        var t = window.BBLeadSource.adTag();
        if (t && !input.value) input.value = t;
      });
    }
  }

  function peek() {
    return window.BBHouseLogo ? window.BBHouseLogo.peek() : Promise.resolve(null);
  }

  function initDesigns(box) {
    if (box.dataset.bbhReady) return;
    box.dataset.bbhReady = '1';
    var current = box.getAttribute('data-bbh-product') || '';
    if (current) remember(current);
    var always = box.hasAttribute('data-bbh-always');
    peek().then(function (rec) {
      if (!rec && !always && !box.hasAttribute('data-bbh-posted')) return;
      var pieces = viewed();
      if (current && pieces.indexOf(current) < 0) pieces.unshift(current);
      var pf = box.querySelector('[data-bbh-pieces]');
      if (pf) pf.value = pieces.join(', ');
      var shown = box.querySelector('[data-bbh-pieces-text]');
      if (shown) {
        shown.textContent = pieces.join(', ');
        if (shown.parentNode) shown.parentNode.hidden = !pieces.length; // nothing opened yet: no empty "Pieces:" line
      }
      if (pf && !pieces.length) pf.value = 'None opened yet';
      var lf = box.querySelector('[data-bbh-logo]');
      if (lf && rec) lf.value = rec.name + ' (added on the site; the form can’t send the file)';
      box.hidden = false;
    });
  }

  // the logo name in any other House form (the paid sample request): same read-only peek, same words as the designs
  // form. The designs box fills its own field in initDesigns.
  function initLogoField(input) {
    if (input.closest('[data-bbh-designs]')) return;
    peek().then(function (rec) { if (rec) input.value = rec.name + ' (added on the site; the form can’t send the file)'; });
  }

  function initApprove(input) {
    if (input.dataset.bbhReady || !window.BBDates) return;
    input.dataset.bbhReady = '1';
    var D = window.BBDates;
    var line = document.getElementById(input.getAttribute('data-bbh-approve'));
    input.min = D.todayISO();
    if (input.value && input.value < input.min) input.value = ''; // a stale past date would block sending an optional field
    var form = input.closest('form'), sent = null;
    if (form) {
      sent = form.querySelector('input[name="contact[Approve proof by]"]');
      if (!sent) {
        sent = document.createElement('input');
        sent.type = 'hidden';
        sent.name = 'contact[Approve proof by]';
        input.parentNode.appendChild(sent);
      }
    }
    function show() {
      var iso = input.value, today = D.todayISO(), text = '', value = '';
      if (D.parseISO(iso) && iso >= today) {
        if (D.canPromise(iso, today)) {
          text = 'For this date, approve your proof by ' + D.fmtDay(D.approveByDate(iso)) + '.';
          value = D.fmtDate(D.approveByDate(iso));
        } else {
          text = 'Sooner than we can promise. Our earliest is about ' + D.fmtDay(D.earliestFrom(iso, today)) + '. Send it anyway and we’ll tell you plainly what’s possible.';
          value = 'Sooner than we can promise (earliest in hands about ' + D.fmtDate(D.earliestFrom(iso, today)) + ')';
        }
      }
      if (sent) sent.value = value;
      if (line && line.textContent !== text) line.textContent = text;
    }
    input.addEventListener('change', show);
    input.addEventListener('input', show);
    show();
  }

  function initStored(note) {
    if (note.dataset.bbhReady) return;
    note.dataset.bbhReady = '1';
    peek().then(function (rec) {
      if (!rec) return;
      var nm = note.querySelector('[data-bbh-stored-name]');
      if (nm) nm.textContent = rec.name;
      var hidden = note.querySelector('input[type="hidden"]');
      if (hidden) hidden.value = rec.name;
      note.hidden = false;
      // the form can't carry the file, so "I'll email it" is ticked for them (they can untick it)
      var set = note.closest('fieldset') || note.parentNode;
      var link = set && set.querySelector('input[name*="Logo link"]');
      var tick = set && set.querySelector('input[type="checkbox"][name*="emailing it"]');
      if (tick && !tick.checked && !(link && link.value.trim())) tick.checked = true;
    });
  }

  // the cart's lines, read again at send time (the cart page changes quantities without a reload)
  function usd(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function cartLines(c) {
    return (c.items || []).map(function (i) {
      var v = i.variant_title && !/default/i.test(i.variant_title) ? ' (' + i.variant_title + ')' : '';
      return i.product_title + v + ' x ' + i.quantity + ': ' + usd(i.final_line_price);
    }).join(' | ');
  }
  window.BBHouseForms.cartLines = cartLines;
  // Read the cart again when the form is opened or used, never at send: Shopify's own bot check (hCaptcha) takes over
  // the contact form's submit, and a form that re-sends itself would skip it.
  function freshCart(form) {
    var lines = form.querySelector('input[name="contact[Cart]"]');
    if (!lines) return false;
    var total = form.querySelector('input[name="contact[Cart total]"]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var busy = false, last = 0;
    function refresh() {
      if (busy || Date.now() - last < 1500) return;
      busy = true;
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { lines.value = cartLines(c); if (total) total.value = usd(c.total_price); })
        .catch(function () { /* keep the lines the page was drawn with */ })
        .then(function () { busy = false; last = Date.now(); });
    }
    var details = form.querySelector('details');
    if (details) details.addEventListener('toggle', function () { if (details.open) refresh(); });
    form.addEventListener('focusin', refresh);
    function again(e) { ((e && e.promise) || Promise.resolve()).then(function () { last = 0; refresh(); }, function () {}); }
    document.addEventListener('shopify:cart:lines-update', again);
    document.addEventListener('cart:update', again);
    return true;
  }

  function initSignoff(box) {
    if (box.dataset.bbhReady) return;
    box.dataset.bbhReady = '1';
    var form = box.closest('form');
    if (form && freshCart(form)) return;
    var packField = box.querySelector('[data-bbh-signoff-pack]');
    var mapEl = box.querySelector('[data-bbh-signoff-variants]');
    var fid = box.getAttribute('data-variant-form');
    if (!form || !packField || !mapEl || !fid) return;
    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    function fill() {
      var pf = document.getElementById(fid);
      var idInput = pf && pf.querySelector('[name="id"]');
      var line = idInput && map[String(idInput.value)];
      if (line) packField.value = line;
    }
    // the pack picked goes along: kept current as the buyer changes it, and once more as the form is sent
    // (Horizon swaps the variant a moment after the click: its own event, with later tries as a backstop)
    function after(e) { ((e && e.promise) || Promise.resolve()).then(function () { setTimeout(fill, 0); }, function () {}); }
    document.addEventListener('shopify:product:select', after);
    document.addEventListener('variant:update', after);
    document.addEventListener('change', function () { [400, 1500, 3000].forEach(function (ms) { setTimeout(fill, ms); }); });
    form.addEventListener('submit', fill);
    fill();
    var ih = document.querySelector('[data-bbh-inhand-input]');
    var date = form.querySelector('[data-bbh-remind-date]');
    if (ih && date) {
      ih.addEventListener('change', function () {
        if (date.value || !ih.value) return;
        date.value = ih.value;
        date.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  function initRemind(tick) {
    if (tick.dataset.bbhReady) return;
    tick.dataset.bbhReady = '1';
    var form = tick.closest('form');
    var date = form && (form.querySelector('[data-bbh-remind-date]') || form.querySelector('input[type="date"]'));
    if (!date) return;
    var wasRequired = date.required;
    function sync() { date.required = wasRequired || tick.checked; }
    tick.addEventListener('change', sync);
    sync();
  }

  var SHARE_COPIED = 'Link copied. Paste it into an email to yourself.';
  function initShare(box) {
    if (box.dataset.bbhReady) return;
    box.dataset.bbhReady = '1';
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (!coarse) return;
    peek().then(function (rec) { box.hidden = !!rec; });
    var btn = box.querySelector('[data-bbh-share-btn]');
    var done = box.querySelector('[data-bbh-share-done]');
    function say(t) { if (done) done.textContent = t; }
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = window.location.href;
      function copy() {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { say(SHARE_COPIED); }, function () { say(url); });
        } else {
          say(url);
        }
      }
      if (navigator.share) {
        // closing the sheet is an AbortError: nothing to do. Anything else (an in-app browser refusing): copy instead
        navigator.share({ title: document.title, url: url }).catch(function (e) { if (!e || e.name !== 'AbortError') copy(); });
        return;
      }
      copy();
    });
  }

  function all() {
    document.querySelectorAll('[data-bbh-signoff]').forEach(initSignoff);
    document.querySelectorAll('input[type="checkbox"][data-bbh-remind]').forEach(initRemind);
    document.querySelectorAll('[data-bbh-share]').forEach(initShare);
    document.querySelectorAll('[data-bbh-designs]').forEach(initDesigns);
    document.querySelectorAll('input[data-bbh-logo]').forEach(initLogoField);
    document.querySelectorAll('input[type="date"][data-bbh-approve]').forEach(initApprove);
    document.querySelectorAll('[data-bbh-stored]').forEach(initStored);
    document.querySelectorAll('input[data-bbh-ad]').forEach(initAd);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
  // a logo added on this very page (Nick's tool announces each save): show the forms without a reload
  window.addEventListener('bb-logo:saved', function () {
    document.querySelectorAll('[data-bbh-designs]').forEach(function (b) { delete b.dataset.bbhReady; initDesigns(b); });
    document.querySelectorAll('input[data-bbh-logo]').forEach(initLogoField);
    document.querySelectorAll('[data-bbh-stored]').forEach(function (n) { delete n.dataset.bbhReady; initStored(n); });
    document.querySelectorAll('[data-bbh-share]').forEach(function (b) { b.hidden = true; });
  });
})();
